import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'murder-hornet-ui';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { useLogoutMutation, useGetOrganizationBrandingQuery } from '../../redux/reducers/auth';
import { history } from '../../routers/AppRouter';
import SideNavSection from './SideNavSection';

const SideNav = ({ isOpen, toggle }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const organization_uuid = useSelector((state) => state.auth.organization_uuid);

  const { data: organizationBranding = {} } = useGetOrganizationBrandingQuery(organization_uuid, { skip: !organization_uuid });
  const [logout] = useLogoutMutation();

  const location = useLocation();

  const [, primaryPath] = location.pathname.split('/');

  return (
    <nav className={`sidenav border-end ${isOpen ? 'active' : ''}`}>
      <div className='d-flex justify-content-between p-3'>
        <div className='sidenav-logo d-flex justify-content-start justify-content-sm-center'>
          {organizationBranding.logo_url && (
            <img
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  history.push('/');
                }
              }}
              className='pointer'
              style={{ maxHeight: '100%', maxWidth: '100%' }}
              src={organizationBranding.logo_url} title='organization logo'
              onClick={() => history.push('/')}
            />
          )}
        </div>

        {/* Mobile SideNav close button */}
        <div className='d-sm-none'>
          <Button ghost onClick={toggle}>
            <span className='fas fa-times' />
          </Button>
        </div>
      </div>

      {organizationBranding.name && <p className='fs-5 fw-bold mb-0 px-3 pb-3'>{organizationBranding.name}</p>}



      {isLoggedIn && (
        <>
          <Button
            ghost
            block
            className={`bg-light-hover pointer ps-3 pe-3 py-2 mb-3 rounded-0 text-reset fw-normal text-start ${primaryPath === 'dashboard' ? 'bg-primary-subtle fw-semibold' : ''}`}
            onClick={(e) => {
              history.push('/dashboard');
              if (e.currentTarget === document.activeElement) {
                e.currentTarget.blur();
              }
              if (window.innerWidth <= 576) toggle();
            }}
          >
            Dashboard
          </Button>

          <SideNavSection
            title='Settings'
            toggle={toggle}
            items={[
              {
                id: 1,
                title: 'My Settings',
                onClick: () => history.push('/my-settings'),
                isActive: primaryPath === 'my-settings',
              },
              {
                id: 9,
                title: 'Logout',
                onClick: logout,
              },
            ]}
          />
        </>
      )}
    </nav>
  );
};

SideNav.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
};

export default SideNav;
